import "@fontsource/montserrat";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/900.css";
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";

export const onRouteUpdate = ({ location }: { location: any }) => {
  initializeAndTrack(location);
};
